import React from 'react';
import { estadoPagamentoLegado } from './pagamentoLegadoPolicy';

/** O grupo do título identifica o plano, mas não qual previsão pertence a esta conta. */
export default function PagamentoLegadoContextual({ previsoes }) {
    if (!Array.isArray(previsoes) || previsoes.length === 0) return null;
    return (
        <div className="fin-pp__legado" onClick={e => e.stopPropagation()}>
            <div className="fin-pp__cell-muted">Previsões do plano — sem vínculo individual com esta conta:</div>
            {previsoes.map(p => {
                const estado = estadoPagamentoLegado(p.pagamento_legado);
                const data = p.data_pagamento ? String(p.data_pagamento).slice(0, 10).split('-').reverse().join('/') : 'sem data';
                return <div key={p.id} style={{ marginTop: 4 }}>
                    <span>Previsão {p.id} · {data} · R$ {Number(p.valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                    {estado && <span className={'fin-pp__pill ' + (estado.paga ? 'is-warn' : 'is-muted')} style={{ marginLeft: 6 }}>{estado.titulo}</span>}
                </div>;
            })}
        </div>
    );
}
